import { createContext } from "react";

const FormContext = createContext({
  validatePristine: null,
});

export default FormContext;
